import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";

/**
 * Botão de alternância de tema — porta `data-theme-toggle` do legado
 * (`app/web/js/app.js`: alterna `data-theme` na raiz do documento, persiste
 * em `localStorage["ea-theme"]`, ícone lua/sol conforme o tema atual).
 *
 * Aqui quem persiste/aplica é o `next-themes` (configurado em
 * `app/providers.tsx` com `storageKey="ea-theme"` — mesma chave do legado,
 * para não perder a preferência de quem já usa o painel antigo — e
 * `attribute="class"`, que casa com a estratégia `.dark` que a Foundation
 * definiu em `src/styles/globals.css`).
 */
export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  // `resolvedTheme` só é confiável depois do mount (next-themes lê
  // localStorage/matchMedia num efeito) — evita um flash claro/escuro
  // errado no ícone antes disso.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const isDark = mounted && resolvedTheme === "dark";

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="gap-2"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label="Alternar tema"
    >
      {isDark ? <Sun className="size-4" aria-hidden="true" /> : <Moon className="size-4" aria-hidden="true" />}
      <span className="hidden sm:inline">{isDark ? "Claro" : "Escuro"}</span>
    </Button>
  );
}
